const serverPublicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCSx1qnXrozo1KdRXU6ENGiLstZ
mYDYJLFJdr6jYHAbzMerjAk6mB24Xn05HZDKDiWrnNxFIlOvYmg9Cd8iYbAt1o5a
BKPmINylW1pJuEHWlmyydz9XyQSMZ6sx9B9xhl1ar5weegh2UIdJYxC+Rk1GxwDq
/idRkMhlOfC1xfJX6wIDAQAB
-----END PUBLIC KEY-----`;

export default serverPublicKey;